module.exports = __webpack_public_path__ + "banquet/components/InventoryRecordDetail/images/logo_delectable_mark_2x.7ddb241b8fce0eed3cb839715cd056b6.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/InventoryRecordDetail/images/logo_delectable_mark_2x.png
// module id = 1673
// module chunks = 1